export const helpCenterUrl = 'https://stage2.10n.com/help-center';
export const privacyPolicyURL = 'https://alaricsecurities.com/privacy-policy/';
export const shortSellingInfo = 'https://stage2.10n.com/features/#short-selling';
export const contactSupportUrl = 'https://stage2.10n.com/landing';

export const FAVOURITE_SYMBOLS_MAX_LIMIT = 15;
export const SHORT_SELL_DAILY_INTEREST_FEE = 0.00016;
